"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_OPERATOR_TYPES = exports.OPERATOR_TYPES = exports.SELECTION_TYPES = exports.FORMULA_TYPES = exports.FORMULA = exports.EQUALS = exports.RANGE_CONTAINS = void 0;
var RANGE_CONTAINS = 'rangeContains';
exports.RANGE_CONTAINS = RANGE_CONTAINS;
var EQUALS = 'equals';
exports.EQUALS = EQUALS;
var FORMULA = 'formula';
exports.FORMULA = FORMULA;
var FORMULA_TYPES = {
  FORMULA: 'formula',
  GREATER_THAN: 'greaterThan',
  GREATER_THAN_EQUAL_TO: 'greaterThanEqualTo',
  LESS_THAN: 'lessThan',
  LESS_THAN_EQUAL_TO: 'lessThanEqualTo'
};
exports.FORMULA_TYPES = FORMULA_TYPES;
var SELECTION_TYPES = {
  SELECT: 'SELECT',
  FORMULA: 'FORMULA'
};
exports.SELECTION_TYPES = SELECTION_TYPES;
var OPERATOR_TYPES = {
  IN: "in",
  NOT_IN: "notIn",
  GREATER_THAN: "greaterThan",
  LESS_THAN: "lessThan",
  GREATER_THAN_OR_EQUAL_TO: "greaterThanOrEqualTo",
  LESS_THAN_OR_EQUAL_TO: "lessThanOrEqualTo"
};
exports.OPERATOR_TYPES = OPERATOR_TYPES;
var SELECT_OPERATOR_TYPES = {
  IN: "in",
  NOT_IN: "notIn"
};
exports.SELECT_OPERATOR_TYPES = SELECT_OPERATOR_TYPES;